import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_LIST_HOPDONGDELETE } from "../actions/DanhSachHopDongDelete/actionTypes";
import {
  getListHopDongDeleteSuccess,
  getListHopDongDeleteFailure,
} from "../actions/DanhSachHopDongDelete";
import DanhSachHopDongDeleteApi from "../service/danhSachHopDongDeleteApi";

function* getListHopDongDelete(action) {
  try {
    const response = yield call(
      DanhSachHopDongDeleteApi.GetDanhSachHopDongDelete,
      action.dataSearch
    );
    if (response.ok) {
      yield put(getListHopDongDeleteSuccess(response.data));
    } else {
      yield put(getListHopDongDeleteFailure());
    }
  } catch (error) {
    yield put(getListHopDongDeleteFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_HOPDONGDELETE, getListHopDongDelete);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}

// import { all, call, put, takeLatest } from "redux-saga/effects";
// import { GET_LIST_HOPDONGDELETE } from "../actions/DanhSachHopDongDelete/actionTypes";
// import {
//   getListHopDongDeleteSuccess,
//   getListHopDongDeleteFailure,
// } from "../actions/DanhSachHopDongDelete";
// import DanhSachHopDongDeleteApi from "../service/danhSachHopDongDeleteApi";

// function* getListHopDongDelete(action) {
//   try {
//     const response = yield call(
//       DanhSachHopDongDeleteApi.GetDanhSachHopDongDelete,
//       action.dataSearch
//     );
//     if (response.ok) {
//       yield put(getListHopDongDeleteSuccess(response.data));
//     } else {
//       yield put(getListHopDongDeleteFailure());
//     }
//   } catch (error) {
//     yield put(getListHopDongDeleteFailure());
//   }
// }

// function* watchGetRequest() {
//   yield takeLatest(GET_LIST_HOPDONGDELETE, getListHopDongDelete);
// }

// export default function* sagas() {
//   yield all([watchGetRequest()]);
// }
